import * as React from "react";
const SvgGoogleSlide = (props) => (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", ...props },
    React.createElement("path", { fill: "#FFE262", d: "m14 2 6 6h-6z" }),
    React.createElement("path", { fill: "#FFBE2C", d: "M4 5a3 3 0 0 1 3-3h7v3a3 3 0 0 0 3 3h3v11a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3z" }),
    React.createElement("path", { fill: "#fff", d: "M8 11h8v2H8z" }),
    React.createElement("path", { fill: "#fff", d: "M15 11h1v7h-1zM8 11h1v7H8z" }),
    React.createElement("path", { fill: "#fff", d: "M8 16h8v2H8z" })));
export default SvgGoogleSlide;
//# sourceMappingURL=GoogleSlide.js.map